var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgMotionPathDesktop = function SvgMotionPathDesktop(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "motion_path_desktop_svg__path-desktop",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 500",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "motion_path_desktop_svg__motion-path",
    d: "M0-1A958.4486,958.4486,0,0,0,250,50c71.7111,4.7828,132.11-.6562,250-12C729.8876,15.8794,836.8679-11.3027,897,50c18.7973,19.1632,32.9411,46.896,34,49,5.9084,11.74,20.7348,43.9336,21,150,.2725,108.9837-15.2194,139.5058-21,150-7.9522,14.4366-19.2131,34.88-41,51-63.7529,47.1714-137.3594-2.0694-258,11-32.0624,3.4734-77.8854,12.4788-132,38",
    style: {
      fill: "none"
    }
  }));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgMotionPathDesktop);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/motion_path_desktop.64ec12721895d6f35399101bf2c37564.svg";